<!--
 * @Author: Merlin
 * @Date: 2025-07-03 15:49:06
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-08 11:39:01
 * @Description: 
    * 该页面不会被实际访问，这是空文件，中间件会重定向至此的访问
    * 这文件不能删除，删除后至此的访问将报错：并提示 "No match found for location"
-->

<template>

</template>

<script lang="ts">
export default defineComponent({ 
    created(){
        // 以下内容永远不会被打印，因为访问此页时会被中间件重定向 
        if (import.meta.client){
            console.log('[created()] 正在访问 zhajinhuaGame indoor');
        }
    },
});
</script>
